import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';
import Routes from './routes';

/**
 * TELV1-354 — redirect bare org-scoped paths (e.g. `/profile`,
 * `/organizational-settings`, `/projects-rebranding`) to their nested
 * form under the user's current org (`/organization/<id>/profile`).
 *
 * Bookmarks / pasted URLs / shared links to the bare path used to fall
 * through to the catch-all `*` route → `Error404Page` ("Something
 * missing"), because the real route is only registered at
 * `${Routes.organization.path}/:organization_id<subPath>`. In-app
 * navigation (UserIconDropDown) correctly builds the full nested path,
 * so only out-of-app entry points hit the 404.
 *
 * Cookie strategy mirrors `App.tsx`/`/`: read `main_organization` for
 * the fast path; if absent, fall back to `Routes.home.path` so
 * `App.tsx`'s `processAuthSuccess` re-resolve handles missing-cookie
 * cases (e.g. cleared cookies but valid token) — same recovery pattern
 * as TELV1-278 for fast-path-with-missing-cookie.
 */
type Props = {
  subPath: string;
};

export function OrgScopedRedirect({ subPath }: Props) {
  const mainOrganization = Cookies.get('main_organization');

  if (mainOrganization) {
    return <Navigate to={`${Routes.organization.path}/${mainOrganization}${subPath}`} replace />;
  }

  return <Navigate to={Routes.home.path} replace />;
}
